import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { hasPermission, isAdmin, isUtilAdmin } from "./common/authentification-functions";
import { ApplicationRoutes } from "../routes";

interface PermissionGuardProps {
    permission: number;
    children: React.ReactNode;
}

export default function PermissionGuard({ permission, children }: PermissionGuardProps) {
    const allowed = hasPermission(permission);

    useEffect(() => {
        if (!allowed) {
            toast.error("You don't have permission to access this page.");
        }
    }, [allowed]);

    if (!allowed) {
        // Send the user back to their own portal's home rather than a 404.
        const redirectTo = isAdmin()
            ? `/${ApplicationRoutes.ADMIN_BASE}`
            : isUtilAdmin()
            ? `/${ApplicationRoutes.ADMIN_UTIL_BASE}`
            : `/${ApplicationRoutes.DASHBOARD}`;
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
}
